import Marquee from "react-fast-marquee";

const items = [
  "Resume Writing", "LinkedIn Optimization", "Career Consulting",
  "ATS Strategy", "Executive Branding", "Interview Coaching", "Cover Letters",
];

export default function ServicesMarquee() {
  return (
    <section className="bg-secondary/60 border-y border-border py-6 overflow-hidden" data-testid="marquee-section">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-3xl lg:text-4xl text-navy/85 px-10">{it}</span>
            <span className="w-2 h-2 rounded-full bg-cobalt" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
